



















































import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '../../mixins/pagination'
import { SearchItemType, TableColumnItemType, OperationItemType, OptionItemType } from '../../types/type'
import { CommonModule, UserModule } from '../../store'
import { getAllFatherNodeForTree, disposeSearchParamsForCM, getArrChildForTree } from '../../utils/toolsForCommon'
@Component({
  name: 'Train',
  mixins: [Pagination],
  components: {
    'search-module': () => import('../../components/common/searchModule.vue'),
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'table-module': () => import('../../components/common/tableModule.vue')
  }
})
export default class Train extends Vue {
  public loading = false
  // 搜索条件的最终选中项：
  public searchCheckList: Array<string> = []
  // 所有搜索条件：
  public searchList: Array<SearchItemType> = [
    {
      title: '学校',
      key: 'organizationNameForTrain',
      type: 'cascader',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      show: true,
      disabled: true
    },
    {
      title: '培训时间',
      key: 'dateInterval',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择培训时间',
      show: true,
      disabled: false
    },
    {
      title: '培训内容',
      key: 'trainingContent',
      type: 'input',
      value: '',
      placeholder: '请输入培训内容',
      show: true,
      disabled: false
    }
  ]
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '乡镇',
      key: 'townStr',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '180px'
    },
    {
      title: '学校',
      key: 'school',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum',
      width: '200px'
    },
    {
      title: '培训时间',
      key: 'time',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '180px'
    },
    // {
    //   title: '培训类型',
    //   key: '',
    //   type: 'text',
    //   showStateForTableHeader: 'unilaminar',
    //   needTransformForResult: 'enum',
    //   width: '180px'
    // },
    {
      title: '培训内容',
      key: 'trainingContent',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '培训人数',
      key: 'joinAmount',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '培训图片',
      key: 'picture',
      type: 'imageList',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '备注',
      key: 'comment',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '删除',
      key: 'delete',
      type: 'danger',
      size: 'mini'
    }
  ]
  // 枚举选项：
  public optionsForTrainType: Array<OptionItemType> = [
    {
      name: '技能培训',
      value: 1
    },
    {
      name: '安全培训',
      value: 2
    }
  ]

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.disposeSearchCheckedInit()
    this.disposeForSearchList()
    this.getTableDataList()
  }

  // 选择项初始化：
  disposeSearchCheckedInit () {
    // this.searchCheckList = this.searchList.length > 2 ? this.searchList.slice(0, 2).map(item => item.key) : this.searchList.slice(0).map(item => item.key)
    this.searchCheckList = this.searchList.slice(0).map(item => item.key)
  }

  // 选择项数据处理：
  disposeForSearchList () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        case 'organizationNameForTrain':
          item.treeData = this.treeDataForSubOrganatizion
          // item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          // // 有学校的话就默认勾选第一所：
          // const arrChildForTree = getArrChildForTree(this.treeDataForSubOrganatizion, 'children')
          // let firstSchool: any = ''
          // if (arrChildForTree.length) {
          //   firstSchool = arrChildForTree[0]
          //   item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', firstSchool.id)
          // }
          break
      }
      return item
    })
  }

  operationForAddOrUpdate (id: string) {
    this.$router.push({
      name: 'AddOrUpdateTrain',
      query: {
        id
      }
    })
  }

  // 操作按钮：
  operationForButton ({ key }, row) {
    const { id, outOrIn } = row
    switch (key) {
      case 'delete':
        this.operationForDelete(id)
        break
    }
  }

  // 删除：
  operationForDelete (id: string) {
    this
      .$confirm('确定要删除此培训记录吗?', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消删除',
        type: 'error'
      })
      .then(async () => {
        let { data: result } = await (this as any).$http.dailyTrainingDel({ id })
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success('删除成功！')
        this.getTableDataList()
      })
      .catch(() => {})
  }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
      const params = {
        ...pageParams,
        ...searchParams
      }
      const { data: result } = await (this as any).$http.dailyTrainingQuery(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = ((result.data && result.data.records) || []).map(item => {
        item.time = (item.time || '暂无').split(' ')[0]
        item.picture = item.picture ? item.picture.split(',') : []
        return item
      })
      _that.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  resetBtn () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        // case 'organizationNameForTrain':
        //   item.treeData = this.treeDataForSubOrganatizion
        //   item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
        //   // 有学校的话就默认勾选第一所：
        //   const arrChildForTree = getArrChildForTree(this.treeDataForSubOrganatizion, 'children')
        //   let firstSchool: any = ''
        //   if (arrChildForTree.length) {
        //     firstSchool = arrChildForTree[0]
        //     item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', firstSchool.id)
        //   }
        //   break
        default:
          item.value = ''
          break
      }
      return item
    })
  }

  searchBtn (searchCheckListSelf) {
    let _that: any = this
    _that.currentPage = 1
    _that.pageSize = 10
    this.searchCheckList = searchCheckListSelf
    this.getTableDataList()
  }
}
